module.exports = __webpack_public_path__ + "static/media/12-6.41f24027.mp3";